import React from 'react';
import { Modal, ModalBody, ModalContent } from "@heroui/react";

interface TutorialModalProps {
  onOpen: boolean;
  onClose: () => void;
  videoUrl: string;
}
const TutorialModal: React.FC<TutorialModalProps> = ({
  onOpen,
  onClose,
  videoUrl,
}) => {
  return (
    <Modal
      isOpen={onOpen}
      onOpenChange={onClose}
      size="5xl"
      className="h-[495px] bg-transparent shadow-none sm:w-[720px] sm:h-[405px]"
      classNames={{ closeButton: 'hidden' }}
    >
      <ModalContent>
        <ModalBody className="flex items-center justify-center">
          <iframe
            className="w-[880px] h-[495px] sm:w-[720px] sm:h-[405px] rounded-xl"
            src={videoUrl}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
            title="Wisedoc Tutorials"
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
export default TutorialModal;
